import React, { Component } from "react";
import IconSearch from "ReactComponents/Shared/Icons/icon-search";
import { searchComposer } from "../../ReactReducers/Search/search-composer";

/**
 * @param SearchBoxText (string) the placeholder text
 *
 */

class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.submitHandler = this.submitHandler.bind(this);
    }

    submitHandler(e) {
        e.preventDefault();

        if (window) {
            //window.location = '/soeg?q=' + this.props.query;
            if (window.location.pathname.indexOf("/soeg") != -1) {
                window.history.replaceState({}, "", "/soeg?q=" + this.props.query);
                this.props.searchSubmit(this.props);
            } else {
                window.location = "/soeg?q=" + this.props.query;
            }
        }
    }

    searchChange(event) {
        this.props.queryChanged(event.target.value);
    }

    render() {
        return (
            <div className="search-box">
                <form onSubmit={this.submitHandler}>
                    <input
                        type="text"
                        className="search-box__input"
                        placeholder={this.props.SearchBoxText}
                        value={this.props.query}
                        onChange={event => this.searchChange(event)}
                    />
                    <button aria-label="Søg" type="submit" className="search-box__submit">
                        <IconSearch />
                    </button>
                </form>
            </div>
        );
    }
}

export default searchComposer(SearchBox);
